import React from 'react'

import { Drawer, useDisclosure } from '@chakra-ui/react'
import { useBlockTransition } from 'src/hooks/useBlockTransition'

import { AddIcfDocumentRevisionRenewal } from './add-revision-renewal'
import { useAddIcfDocumentRevision } from './add-revision.hooks'
import { RevisionHistoryContainer } from '../revision-history/revision-history-container'

export const AddIcfDocumentRevisionContainer: React.FC = () => {
  const {
    icfDocument,
    nextRevision,
    editing,
    filePreviewUrl,
    listPath,
    editPath,
    errors,
    shouldSelectHospital,
    hospitalName,
    hasMultipleRevisionHistories,
    hasTempFile,
    pullDownState,
    submitModalState,
    onChangeName,
    onChangeVersion,
    onChangeRequiredPatientSign,
    onSelectFile,
    onValidate,
    onSubmit,
    onCancel,
  } = useAddIcfDocumentRevision()

  const { isOpen, onOpen, onClose } = useDisclosure()

  useBlockTransition({
    showAlert: editing,
  })

  return (
    <>
      <Drawer isOpen={isOpen} onClose={onClose} size="xl">
        <RevisionHistoryContainer />
      </Drawer>
      <AddIcfDocumentRevisionRenewal
        icfDocument={icfDocument}
        nextRevision={nextRevision}
        filePreviewUrl={filePreviewUrl}
        listPath={listPath}
        editPath={editPath}
        errors={errors}
        shouldSelectHospital={shouldSelectHospital}
        hospitalName={hospitalName}
        hasMultipleRevisionHistories={hasMultipleRevisionHistories}
        hasTempFile={hasTempFile}
        pullDownState={pullDownState}
        submitModalState={submitModalState}
        onValidate={onValidate}
        onChangeName={onChangeName}
        onChangeVersion={onChangeVersion}
        onChangeRequiredPatientSign={onChangeRequiredPatientSign}
        onSelectFile={onSelectFile}
        onSubmit={onSubmit}
        onCancel={onCancel}
        openRevisionHistoryPane={onOpen}
      />
    </>
  )
}
